import React, { useState, useEffect } from 'react';
import moment from 'moment';  // Make sure you have moment.js installed

const DateComponent = () => {
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    // Get the current date using moment and format it
    const formattedDate = moment().format("ddd D MMM");
    setCurrentDate(formattedDate);
  }, []);  // Empty dependency array to run only once when the component mounts

  return (
    <div id = "introDate">
      <h4 id="showDate">{currentDate}</h4>
    </div>
  );
};

export default DateComponent;